import { LocalStorage } from 'quasar'

const PROD_HOSTNAME_SUFFIX = 'peg.com'
/**
 * Get the current hostname
 * Extracted into a function for testability (Cypress can stub this)
 * @returns {string} The current hostname
 */
export function getHostname() {
  // Use stub if available (for cypress testing)
  return window?.__cyUtils?.getHostname() || window.location.hostname
}

/**
 * Check if the current environment is production site
 * @returns {boolean} True if production site based on hostname and env variable
 */
export function isTrueProduction() {
  return import.meta.env.VITE_TARGET_ENV === 'production' && getHostname().endsWith(PROD_HOSTNAME_SUFFIX)
}

/**
 * Check for the non-prod site access flag in localStorage
 * @returns {boolean} True if 'peg_np_access' flag is set to 'true'
 */
export function hasNonProdAccessFlag() {
  return LocalStorage.getItem('peg_np_access')
}

/**
 * Set non-prod site access flag in localStorage
 */
export function setNonProdAccessFlag(bool) {
  LocalStorage.setItem('peg_np_access', bool)
}
